<template>
  <div class="page_style lanmupage page_l61">
    <div class="top_box">
      <div class="top_box_inner">
        <div class="topcontent">
          <div class="Most-top">
            <div style="float: left">
              {{ formattedDate }}
            </div>
            <div style="float: right">
              <a @click="setHome" href="#" class="top-swsy">设为首页</a> |
              <a @click="addToFavorites" href="#" class="top-jrsc">加入收藏</a>
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="logo">
          <a href="/" style="display: block"
            ><img src="../assets/picture/logo.png" alt="Logo" border="0"
          /></a>
        </div>
        <div class="menu_box" id="Menu">
          <ul>
            <li
              v-for="(menuItem, index) in menuItems"
              :key="index"
              :class="['menu_style', { menu_current: menuItem.active }]"
            >
              <a @click="toPath(menuItem)" class="menu">{{ menuItem.name }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="main_box main_box_style">
      <div class="main_box_inner">
        <!-- Module 288 -->
        <div class="module_box_layout_left" style="width: 700px">
          <div class="module_box_inner">
            <div class="module_content">
              <div class="inner1">
                <table
                  class="scroll-table"
                  border="0"
                  align="center"
                  cellpadding="0"
                  cellspacing="0"
                >
                  <tr
                    v-for="(article, index) in articles"
                    :key="'first-' + index"
                  >
                    <td class="scroll-item">
                      <a :href="article.link" target="_self">{{
                        article.title
                      }}</a>
                    </td>
                  </tr>
                  <!-- 复制一遍文章列表，形成无缝滚动 -->
                  <tr
                    v-for="(article, index) in articles"
                    :key="'second-' + index"
                  >
                    <td class="scroll-item">
                      <a :href="article.link" target="_self">{{
                        article.title
                      }}</a>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="module_footer">
              <span class="l"></span><span class="r"></span>
            </div>
          </div>
        </div>

        <!-- Module 296 -->
        <div class="module_box_layout_right" style="width: 390px">
          <div class="module_box_inner">
            <div class="module_content module_content_introduct">
              <span style="float: left; font-size: 15px; color: #555"
                >信息搜索:</span
              >
              <form @submit.prevent="handleSearch">
                <input
                  v-model="searchQuery"
                  name="q"
                  type="text"
                  id="searchkw"
                  class="search-input"
                />
                <input type="hidden" name="typeid" value="2" />
                <input
                  style="border: 0px; float: left"
                  type="image"
                  :src="require('../assets/picture/ico19.jpg')"
                />
              </form>
            </div>
            <div class="module_footer">
              <span class="l"></span><span class="r"></span>
            </div>
          </div>
        </div>

        <!-- Module 254 -->
        <div class="module_box_layout_left">
          <div class="module_box_inner">
            <div class="module_content">
              <img
                src="http://www.mohrss.gov.cn/SYrlzyhshbzb/dongtaixinwen/SYtupianxinwen/202503/W020250312460061473713.jpg"
                alt="Image"
                style="height: 267px; width: 593px"
              />
            </div>
          </div>
        </div>

        <!-- Module 289 -->
        <div class="module_box_layout_right" style="width: 500px">
          <div class="module_box_inner">
            <div class="module_content module_content_introduct">
              <!-- Tab Headers -->
              <dl id="tabhead2" class="tabhead1">
                <dd
                  v-for="(tab, index) in tabs"
                  :key="index"
                  @click="activeTab = index"
                  :class="{ active: activeTab === index }"
                >
                  <a href="javascript:void(0)">{{ tab }}</a>
                </dd>
              </dl>

              <!-- Tab Contents -->
              <dl id="tabcontent2" class="tabcontentstyle1">
                <dd
                  v-for="(article, index) in newsArticles"
                  :key="index"
                  v-show="activeTab === index"
                >
                  <div class="article">
                    <ul>
                      <li v-for="(item, idx) in article.items" :key="idx">
                        <span class="title aTitle">
                          <a :href="item.link" target="_self">{{
                            item.title
                          }}</a>
                        </span>
                        <span class="date">{{ item.date }}</span>
                      </li>
                    </ul>
                  </div>
                </dd>
              </dl>
            </div>
            <div class="module_footer">
              <span class="l"></span><span class="r"></span>
            </div>
          </div>
        </div>

        <!-- Module 292 -->
        <div class="module_box_layout_left" style="width: 824px">
          <div class="module_box_inner">
            <div class="module_content module_content_introduct">
              <div class="home-zhjg2">
                <span class="zhjg-title">
                  <img src="../assets/picture/ico5.jpg" />信息公开
                </span>
                <div class="home-wcon">
                  <span
                    style="
                      display: bold;
                      float: left;
                      width: 370px;
                      padding-left: 10px;
                    "
                  >
                    <dl class="tabhead2">
                      <dd
                        @click="policyArticlesActive = 0"
                        :class="{ colorFont: policyArticlesActive == 0 }"
                      >
                        政策法规
                      </dd>
                      <dd
                        @click="policyArticlesActive = 1"
                        :class="{ colorFont: policyArticlesActive == 1 }"
                        style="text-align: center"
                      >
                        行业信息
                      </dd>
                      <dd
                        @click="policyArticlesActive = 2"
                        :class="{ colorFont: policyArticlesActive == 2 }"
                        style="text-align: right"
                      >
                        行业动态
                      </dd>
                    </dl>
                    <dl
                      class="tabcontentstyle2"
                      v-show="policyArticlesActive === index"
                      v-for="(item, index) in policyArticles"
                      :key="index"
                    >
                      <dd>
                        <div class="article">
                          <ul>
                            <li
                              v-for="(items, indexs) in item.items"
                              :key="indexs"
                            >
                              <span class="title">
                                <a :href="items.link" target="_self">{{
                                  items.title
                                }}</a>
                              </span>
                              <span class="date">{{ items.date }}</span>
                            </li>
                          </ul>
                        </div>
                      </dd>
                    </dl>
                  </span>
                  <span
                    style="
                      display: bold;
                      float: right;
                      width: 370px;
                      padding-right: 10px;
                    "
                  >
                    <dl class="tabhead2">
                      <dd
                        @click="healthArticlesActive = 0"
                        :class="{ colorFont: healthArticlesActive == 0 }"
                      >
                        职业分类
                      </dd>
                      <dd
                        @click="healthArticlesActive = 1"
                        :class="{ colorFont: healthArticlesActive == 1 }"
                      >
                        职业标准
                      </dd>
                      <dd
                        @click="healthArticlesActive = 2"
                        :class="{ colorFont: healthArticlesActive == 2 }"
                      >
                        职业资格目录
                      </dd>
                    </dl>
                    <dl
                      class="tabcontentstyle2"
                      v-for="(item, index) in healthArticles"
                      :key="index"
                      v-show="healthArticlesActive === index"
                    >
                      <dd>
                        <div class="article">
                          <ul>
                            <li
                              v-for="(items, indexs) in item.items"
                              :key="indexs"
                            >
                              <span class="title">
                                <a :href="items.link" target="_self">{{
                                  items.title
                                }}</a>
                              </span>
                              <span class="date">{{ items.date }}</span>
                            </li>
                          </ul>
                        </div>
                      </dd>
                    </dl>
                  </span>
                </div>
              </div>
            </div>
            <div class="module_footer">
              <span class="l"></span><span class="r"></span>
            </div>
          </div>
        </div>
        <!-- Module 293 -->
        <div class="module_box_layout_right" style="width: 266px">
          <div class="module_box_inner">
            <div class="module_content module_content_introduct">
              <div class="home-jzxx">
                <a
                  style="
                    width: 265px;
                    height: 89.91px;
                    display: block;
                    margin-top: -20px;
                  "
                >
                  <img
                    src="../assets/picture/1-1q1021g2594t.jpg"
                    style="width: 100%; height: 100%"
                  />
                </a>
              </div>
              <ul style="margin-top: 42%">
                <li
                  v-for="(item, index) in queryArticles"
                  :key="index"
                  style="
                    padding: 0 0 0 10px;
                    display: flex;
                    justify-content: space-between;
                    height: 33px;
                    line-height: 33px;
                  "
                >
                  <span
                    class="title"
                    style="
                      float: left;
                      text-align: left;
                      padding: 0 0 0 11px;
                      background: url(../assets/picture/wen1.png)
                        no-repeat left center;
                      width: 70%;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    <a :href="item.link" target="_self">{{ item.title }}</a>
                  </span>
                  <span class="date">{{ item.date }}</span>
                </li>
              </ul>
              <a style="width: 266px; display: block; margin-top: 9px">
                <img
                  src="../assets/picture/1-1q1021a91o29.jpg"
                  style="width: 100%; height: 100%"
                />
              </a>
              <a
                style="width: 266px; display: block; margin-top: 9px"
                @click="toSearch"
              >
                <img
                  src="../assets/picture/search.png"
                  style="width: 100%; height: 100%"
                />
              </a>
              <!-- <span class="home-sqcx">申请查询</span>
                            <div class="home-wcon" style="text-align:center;padding-top:10px;">
                                <table>
                                    <form action="/chaxun.php" method="post">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <span
                                                        style="float:left;width:65px;height:28px;line-height:28px;text-align:right;font-size:15px;color:#666;">姓名：</span>
                                                    <input v-model="name" required
                                                        style="width:170px;height:28px;border:1px #E0E0E0 solid;" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span
                                                        style="float:left;width:65px;line-height:28px;text-align:right;font-size:15px;color:#666;">证书号：</span>
                                                    <input v-model="certificateNumber" required
                                                        style="width:170px;height:28px;border:1px #E0E0E0 solid;" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <input type="submit" style="margin-top:15px;" value="查询" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </form>
                                </table>
                            </div> -->
            </div>
            <div class="module_footer">
              <span class="l"></span><span class="r"></span>
            </div>
          </div>
        </div>
        <div class="module_box_layout_left" style="width: 824px">
          <div class="module_box_inner">
            <div class="module_content module_content_introduct">
              <div class="home-zhjg2">
                <span class="zhjg-title">
                  <img src="../assets/picture/ico5.jpg" />网上办事
                </span>
                <div class="home-wcon">
                  <span
                    style="
                      display: bold;
                      float: left;
                      width: 370px;
                      padding-left: 10px;
                    "
                  >
                    <dl class="tabhead2">
                      <dd
                        @click="wlActive = 0"
                        :class="{ colorFont: wlActive == 0 }"
                      >
                        在线测评
                      </dd>
                      <dd
                        @click="wlActive = 1"
                        :class="{ colorFont: wlActive == 1 }"
                        style="text-align: center"
                      >
                        课程中心
                      </dd>
                    </dl>
                    <dl
                      v-for="(item, index) in wlList"
                      :key="index"
                      v-show="wlActive === index"
                      class="tabcontentstyle2"
                    >
                      <dd>
                        <div class="article">
                          <ul>
                            <li
                              v-for="(items, indexs) in item.items"
                              :key="indexs"
                            >
                              <span class="title">
                                <a :href="items.link" target="_self">{{
                                  items.title
                                }}</a>
                              </span>
                              <span class="date">{{ items.date }}</span>
                            </li>
                          </ul>
                        </div>
                      </dd>
                    </dl>
                  </span>
                  <span
                    style="
                      display: bold;
                      float: right;
                      width: 370px;
                      padding-right: 10px;
                    "
                  >
                    <dl class="tabhead2">
                      <dd
                        @click="pxActive = 0"
                        :class="{ colorFont: pxActive == 0 }"
                      >
                        职业培训
                      </dd>
                      <dd
                        @click="pxActive = 1"
                        :class="{ colorFont: pxActive == 1 }"
                      >
                        就业服务
                      </dd>
                    </dl>
                    <dl
                      class="tabcontentstyle2"
                      v-show="pxActive === index"
                      v-for="(item, index) in pxList"
                      :key="index"
                    >
                      <dd>
                        <div class="article">
                          <ul>
                            <li
                              v-for="(items, indexs) in item.items"
                              :key="indexs"
                            >
                              <span class="title">
                                <a :href="items.link" target="_self">{{
                                  items.title
                                }}</a>
                              </span>
                              <span class="date">{{ items.date }}</span>
                            </li>
                          </ul>
                        </div>
                      </dd>
                    </dl>
                  </span>
                </div>
              </div>
            </div>
            <div class="module_footer">
              <span class="l"></span><span class="r"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom_box">
      <div class="link-container" style="margin: 0 auto; width: 1100px">
        <div class="zhjg-title">
          <span class="home-yqlj">
            <img src="../assets/picture/ico13.jpg" />友情链接
          </span>
        </div>
        <dl id="tabcontent7" class="tabcontentstyle3">
          <dd>
            <a
              v-for="(link, index) in firstLinks"
              :key="index"
              :href="link.url"
              >{{ link.name }}</a
            >
          </dd>
        </dl>
      </div>

      <div
        style="
          clear: both;
          overflow: hidden;
          background: #eee;
          height: 100%;
          padding-top: 15px;
          padding-bottom: 15px;
          margin: 0 auto;
        "
      >
        <table align="center">
          <tr>
            <td>
              <p>
                <a @click="$router.push({ path: '/aboutus' })" target="_blank"
                  >关于我们</a
                >
                <a class="footerItem" href="/" target="_blank">隐私声明</a>
                <a class="footerItem" href="/" target="_blank">联系我们</a>
                <a class="footerItem" href="/" target="_blank">版权声明</a>
              </p>
              <p>备案号：晋ICP备2021017782号-2</p>
              <!-- <p>人力资源测评管理中心专项职业能力测评管理委员会版权所有</p> -->
              <p>人力资源测评管理委员会·专项职业能力测评中心版权所有</p>
            </td>
            <!-- <td>
                            <img src="../assets/picture/sydw.png" width="80" height="100" />
                        </td> -->
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo(){
    return {
      title:"人力资源测评管理委员会·专项职业能力测评中心",
      meta:[
        {
          charset: "utf-8"
        },
        {
          name: "keywords",
          content: "人力资源测评管理委员会·专项职业能力测评中心官网",
        },
        {
          name: "description",
          content: "人力资源测评管理委员会专项职业能力测评中心（以下简称中心）是根据《国家中长期人才发展规划》、国务院《国家职业教育改革实施方案》，为了贯彻落实《国务院关于加强职业培训促进就业的意见》、《国务院关于推行终身职业技能培训制度的意见》及人力资源和社会保障部《关于开展单项职业能力考核试点工作的通知》，积极响应中共中央办公厅、国务院办公厅《关于分类推进人才评价机制改革的指导意见》及人力资源和社会保障部〔2017〕68号文件中提出的行业协会、学会等社会组织和企事业单位依据市场需求自行开展能力水平评价工作等政策的指导下经政府行政审批有关部门批准设立的专业第三方人力资源测评机构。",
        }
      ]

    }
  },
  data() {
    return {
      currentDate: new Date(),
      menuItems: [
        { name: "首页", link: "/", active: true },
        { name: "新闻动态", link: "/", active: false },
        { name: "管理委员会", link: "/aboutus", active: false },
        { name: "课程中心", link: "/", active: false },
        { name: "在线测评", link: "/", active: false },
        { name: "党建工作", link: "/", active: false },
        {
          name: "证书查询",
          link: "http://www.sxcpzx.org.cn/select/wap/",
          active: false,
        },
      ],
      searchQuery: "",
      name: "",
      certificateNumber: "",
      articles: [
        {
          title: "人力资源社会保障部关于印发“技能中国行动”实施方案的通知",
          link: "/",
        },
        {
          title:
            "人力资源社会保障部办公厅 关于印发《技能人才评价命题技术规程 试行）》的通知",
          link: "/",
        },
        {
          title:
            "人力资源社会保障部办公厅关于优化技能人员职业资格证书印制发放方式的通知",
          link: "/",
        },
        // Add more articles as needed
      ],
      // 当前选中的tab
      activeTab: 0,
      // tab标题
      tabs: ["图片新闻", "通知公告", "工作动态"],
      newsArticles: [
        {
          items: [
            {
              title: "十四届全国人大三次会议在京闭幕",
              link: "/",
              date: "2025-03-12",
            },
            {
              title: "全国政协十四届三次会议闭幕习近平等出席",
              link: "/",
              date: "2025-03-10",
            },
            {
              title:
                "习近平：强化教育对科技和人才支撑作用形成人才辈出人尽其才才尽其用生动局面",
              link: "/",
              date: "2025-03-07",
            },
            {
              title: "学习贯彻党的二十届三中全会精神专题报告会",
              link: "/",
              date: "2025-03-04",
            },
            {
              title: "春暖助团圆 春风促就业",
              link: "/",
              date: "2025-01-13",
            },
            {
              title: "国新办举行“推动高质量发展”系列主题新闻发布会",
              link: "/",
              date: "2024-09-24",
            },
          ],
        },
        {
          items: [
            {
              title: "关于征集第二批专项职业能力等级测评试点用人单位的通告",
              link: "/",
              date: "2022-10-21",
            },
            {
              title: "关于持续开展新职业信息征集工作的通告",
              link: "/",
              date: "2022-09-25",
            },
            {
              title: "关于进一步规范专项职业能力等级证书样式及有关工作的通知",
              link: "/",
              date: "2023-10-12",
            },
            {
              title: "人力资源社会保障部关于印发“技能中国行动”实施方案的通知",
              link: "/",
              date: "2024-06-30",
            },
            {
              title:
                "人力资源社会保障部办公厅 关于印发《技能人才评价命题技术规程 试行）》的通知",
              link: "/",
              date: "2024-11-15",
            },
            {
              title:
                "人力资源社会保障部办公厅关于优化技能人员职业资格证书印制发放方式的通知",
              link: "/",
              date: "2024-12-27",
            },
          ],
        },
        {
          items: [
            {
              title:
                "人力资源测评管理中心专项职业能力测评管理委员关于职业能力在线测评平台运营的通知",
              link: "/",
              date: "2024-05-31",
            },
            {
              title:
                "人力资源测评管理中心专项职业能力测评管理委员会关于报送职业能力测评共建合作机构信息的通知",
              link: "/",
              date: "2023-08-23",
            },
            {
              title:
                "人力资源测评管理中心专项职业能力测评管理委员关于调整优质线上职业能力培训平台及数字课程资源的通告",
              link: "/",
              date: "2023-12-14",
            },
            {
              title:
                "人力资源测评管理中心专项职业能力测评管理委员会关于支持企业大力开展人才测评工作的通知",
              link: "/",
              date: "2022-11-07",
            },
            {
              title:
                "人力资源测评管理中心专项职业能力测评管理委员会关于开展新职业征集工作的通告",
              link: "/",
              date: "2022-10-08",
            },
            {
              title:
                "人力资源测评管理中心专项职业能力测评管理委员会关于征集部分职业题库资源和题库开发单位的通告",
              link: "/",
              date: "2022-10-25",
            },
          ],
        },
        // More articles for other sections
      ],
      policyArticlesActive: 0,
      policyArticles: [
        {
          items: [
            {
              title:
                "劳动和社会保障部办公厅关于开展单项职业能力考核试点工作的通知",
              link: "/",
              date: "2005-05-08",
            },
            {
              title: "国家中长期人才发展规划纲要(2010－2020年)发布",
              link: "/",
              date: "2010-06-06",
            },
            {
              title: "国务院关于加强职业培训促进就业的意见",
              link: "/",
              date: "2010-10-20",
            },
            {
              title: "中华人民共和国就业促进法",
              link: "/",
              date: "2015-04-24",
            },
            {
              title: "人力资源社会保障部关于公布国家职业资格目录的通知",
              link: "/",
              date: "2017-09-12",
            },
            {
              title:
                "中共中央办公厅 国务院办公厅印发《关于分类推进人才评价机制改革的指导意见》 ",
              link: "/",
              date: "2018-02-26",
            },
            {
              title: "国务院关于印发国家职业教育改革实施方案的通知",
              link: "/",
              date: "2019-02-13",
            },
            {
              title:
                "国务院办公厅关于印发全国深化“放管服”改革优化营商环境电视电话会议重点任务分工方案的通知 ",
              link: "/",
              date: "2019-08-12",
            },
          ],
        },
        {
          items: [
            {
              title:
                "人力资源社会保障部办公厅 市场监管总局办公厅 统计局办公室关于发布智能制造工程技术人员等职业信息的通知",
              link: "/",
              date: "2020-02-25",
            },
            {
              title:
                "人力资源社会保障部办公厅关于做好人力资源社会保障部门职业资格实施机构职能调整有关工作的通知",
              link: "/",
              date: "2020-05-08",
            },
            {
              title:
                "人力资源社会保障部 国家乡村振兴局关于印发《国家乡村振兴重点帮扶地区职业技能提升工程实施方案》的通知",
              link: "/",
              date: "2021-06-28",
            },
            {
              title:
                "人力资源社会保障部关于健全完善新时代技能人才职业技能等级制度的意见（试行）",
              link: "/",
              date: "2022-03-18",
            },
          ],
        },
        {
          items: [
            {
              title:
                "人力资源社会保障部关于进一步加强高技能人才与专业技术人才职业发展贯通的实施意见",
              link: "/",
              date: "2021-01-07",
            },
            {
              title:
                "人力资源社会保障部 国家发展改革委 财政部关于深化技工院校改革大力发展技工教育的意见  ",
              link: "/",
              date: "2021-08-12",
            },
            {
              title:
                "人力资源社会保障部制定出台《关于健全完善新时代技能人才职业技能等级制度的意见（试行）》  ",
              link: "/",
              date: "2022-04-27",
            },
            {
              title:
                "人力资源社会保障部办公厅 公安部办公厅 市场监管总局办公厅关于加强职业技能评价规范管理工作的通知",
              link: "/",
              date: "2024-05-15",
            },
            {
              title:
                "人力资源社会保障部办公厅 市场监管总局办公厅 国家统计局办公室关于发布生物工程技术人员等职业信息的通知",
              link: "/",
              date: "2024-07-25",
            },
          ],
        },

        // More articles for policy
      ],
      healthArticlesActive: 0,
      healthArticles: [
        {
          items: [
            {
              title: "关于印发《劳动力市场职业分类与代码（LB501-2002）》的通知",
              link: "/",
              date: "2005-12-14",
            },
            {
              title:
                "关于聘任国家职业分类大典修订工作专家委员会增补委员的决定 ",
              link: "/",
              date: "2011-11-29",
            },
            {
              title: "国家职业分类大典修订工作启动会在京召开   ",
              link: "/",
              date: "2021-04-28",
            },
            {
              title: "国家职业分类大典（2022年版）公示",
              link: "/",
              date: "2022-07-14",
            },
            {
              title:
                "人社部就中华人民共和国职业分类大典（2022年版）修订等情况举行发布会  ",
              link: "/",
              date: "2022-09-28",
            },
            {
              title:
                "《中华人民共和国职业分类大典（2022年版）》审定颁布会在京召开 ",
              link: "/",
              date: "2022-09-29",
            },
            {
              title: "新版职业分类大典净增158个新职业",
              link: "/",
              date: "2022-09-30",
            },
            {
              title: "国家职业分类大典首次标识数字职业   ",
              link: "/",
              date: "2022-10-28",
            },
          ],
        },
        {
          items: [
            {
              title:
                "人力资源社会保障部办公厅关于颁布网约配送员等18个国家职业技能标准的通知",
              link: "/",
              date: "2021-12-02",
            },
            {
              title:
                "人力资源社会保障部办公厅 应急管理部办公厅关于颁布消防员国家职业技能标准的通知  ",
              link: "/",
              date: "2022-07-19",
            },
            {
              title:
                "人力资源社会保障部办公厅 农业农村部办公厅 国家林业和草原局办公室关于颁布草坪园艺师国家职业技能标准的通知",
              link: "/",
              date: "2022-07-19",
            },
            {
              title:
                "人力资源社会保障部办公厅 工业和信息化部办公厅关于颁布计算机程序设计员等6个国家职业技能标准的通知",
              link: "/",
              date: "2022-08-05",
            },
            {
              title:
                "人力资源社会保障部办公厅关于印发《国家职业标准编制技术规程（2023年版）》的通知",
              link: "/",
              date: "2023-09-11",
            },
            {
              title:
                "人力资源社会保障部办公厅 国家医疗保障局办公室关于颁布健康照护师（长期照护师）国家职业标准的通知 人社厅发〔2024〕14号      ",
              link: "/",
              date: "2024-03-01",
            },
            {
              title:
                "人力资源社会保障部办公厅 关于颁布保健调理师（保健艾灸师）等10个国家职业标准的通知",
              link: "/",
              date: "2024-05-21",
            },
            {
              title:
                "人力资源社会保障部、国家市场监督管理总局、国家统计局联合发布生物工程技术人员等19个新职业   ",
              link: "/",
              date: "2024-07-31",
            },
          ],
        },
        {
          items: [
            {
              title: "【一图看懂】2021年版《国家职业资格目录》究竟有哪些变化？",
              link: "/",
              date: "2021-12-07",
            },
            {
              title:
                "人力资源社会保障部关于公布《国家职业资格目录（2021年版）》的公告  ",
              link: "/",
              date: "2021-11-23",
            },
            {
              title: "人力资源社会保障部公布2021年版《国家职业资格目录》   ",
              link: "/",
              date: "2021-12-02",
            },
            {
              title:
                "《国家职业资格目录（2021年版）》公布后，这样加强监督管理！",
              link: "/",
              date: "2022-04-20",
            },
            {
              title:
                "人力资源社会保障部办公厅关于做好水平评价类技能人员职业资格退出目录有关工作的通知    ",
              link: "/",
              date: "2020-07-20",
            },
            {
              title:
                "水平评价类技能人员职业资格退出职业资格目录有关政策的解读 ",
              link: "/",
              date: "2020-06-28",
            },
            {
              title: "人社部公布国家职业资格目录",
              link: "/",
              date: "2017-09-18",
            },
            {
              title: "人社部印发国家职业资格目录   ",
              link: "/",
              date: "2017-09-15",
            },
          ],
        },
        // More health articles
      ],
      wlActive: 0,
      wlList: [
        {
          items: [
            {
              title: "关于同意开展体重管理师专项职业能力等级测评工作的通知",
              link: "/",
              date: "2025-03-10",
            },
            {
              title: "关于同意开展战略咨询师专项职业能力等级测评工作的通知",
              link: "/",
              date: "2024-12-18",
            },
            {
              title: "关于同意开展用户增长管理师专项职业能力等级测评工作的通知",
              link: "/",
              date: "2024-03-15",
            },
            {
              title: "关于同意开展生涯规划师专项职业能力等级测评工作的通知",
              link: "/",
              date: "2023-10-12",
            },
            {
              title: "关于同意开展制香师专项职业能力等级测评工作的通知",
              link: "/",
              date: "2023-04-17",
            },
            {
              title: "关于同意开展跨境电商店主专项职业能力等级测评工作的通知",
              link: "/",
              date: "2023-02-07",
            },
            {
              title: "关于同意开展民宿主理人专项职业能力等级测评工作的通知",
              link: "/",
              date: "2022-02-21",
            },
          ],
        },
        {
          items: [
            {
              title: "关于印发一体化课程开发技术规程（试行）的通知",
              link: "/",
              date: "2012-04-06 ",
            },
            {
              title: "技工院校工学一体化课程教学改革试点成效 ",
              link: "/",
              date: "2022-04-18",
            },
            {
              title:
                "关于公布31个专业国家技能人才培养工学一体化课程标准和课程设置方案（试用）的通知 ",
              link: "/",
              date: "2022-08-16",
            },
            {
              title: "加强职业教育和技能人才培养",
              link: "/",
              date: "2024-11-13",
            },
            {
              title:
                "人力资源社会保障部办公厅关于印发38个专业国家技能人才培养工学一体化课程标准和课程设置方案的通知",
              link: "/",
              date: "2024-11-18",
            },
            { title: "工人技师带上博士生", link: "/", date: "2024-11-28" },
          ],
        },
        // More health articles
      ],
      pxActive: 0,
      pxList: [
        {
          items: [
            {
              title: "国务院关于推行终身职业技能培训制度的意见",
              link: "/",
              date: "2018-05-08",
            },
            {
              title:
                "人力资源社会保障部关于印发农民工稳就业职业技能培训计划的通知",
              link: "/",
              date: "2020-05-28",
            },
            {
              title:
                "人力资源社会保障部 民政部 财政部 商务部 全国妇联关于实施康养职业技能培训计划的通知  ",
              link: "/",
              date: "2020-10-09",
            },
            {
              title:
                "人力资源社会保障部办公厅关于加快推进 职业技能培训信息化建设有关工作的通知",
              link: "/",
              date: "2022-04-26",
            },
            {
              title: "中共中央印发《干部教育培训工作条例》",
              link: "/",
              date: "2023-10-16",
            },
            {
              title: "中共中央印发《全国干部教育培训规划(2023-2027年)》",
              link: "/",
              date: "2023-10-18",
            },
            {
              title:
                "人力资源社会保障部 中共中央组织部 中央网信办 国家发展改革委 教育部 科技部 工业和信息化部 财政部 国家数据局关于印发《加快数字人才培育支撑数字经济发展行动方案（2024-2026年）》的通知    ",
              link: "/",
              date: "2024-04-02",
            },
          ],
        },
        {
          items: [
            {
              title: "规范零工市场 优化就业服务",
              link: "/",
              date: "2024-04-09",
            },
            {
              title: "扩大就业容量 提升就业质量",
              link: "/",
              date: "2023-03-09 ",
            },
            {
              title:
                "就业服务，始终在身边！——全国人社系统千方百计为群众提供高效优质就业服务",
              link: "/",
              date: "2022-06-20",
            },
            {
              title:
                "国务院办公厅关于进一步做好高校毕业生等青年就业创业工作的通知",
              link: "/",
              date: "2022-05-13",
            },
            {
              title: "国务院关于印发“十四五”就业促进规划的通知 ",
              link: "/",
              date: "2021-08-27",
            },
            { title: "就业服务与就业管理规定", link: "/", date: "2018-12-14" },
            {
              title: "国务院关于做好当前和今后一个时期促进就业工作的若干意见",
              link: "/",
              date: "2018-12-05",
            },
          ],
        },
        // More health articles
      ],
      queryArticles: [
        {
          title: "上海：春风送岗促就业 精准服务助发展",
          link: "/",
          date: "2025-03-14",
        },
        {
          title: "江西: 大力推进家政服务走向职业化",
          link: "/",
          date: "2025-01-13",
        },
        {
          title: "吉林：以赛强技，全面提升职业技能工作水平",
          link: "/",
          date: "2024-10-11",
        },
        {
          title: "北京：在世界技能大赛取得历史最好成绩",
          link: "/",
          date: "2024-09-24",
        },
        {
          title: "天津：扩展境外职业资格认可范围",
          link: "/",
          date: "2024-08-23",
        },
        {
          title: "宁夏: 推出职业技能等级电子证书",
          link: "/",
          date: "2024-07-08",
        },
        {
          title: "青海：创新专业技术人才继续教育政策",
          link: "/",
          date: "2024-07-01",
        },
        {
          title: "湖南: 推动实施“新八级工”制度",
          link: "/",
          date: "2024-06-24",
        },
        // More query articles
      ],
      firstLinks: [
        { name: "国务院", url: "http://www.gov.cn/" },
        { name: "人社部", url: "http://www.mohrss.gov.cn/" },
        { name: "科技部", url: "http://www.most.gov.cn/" },
        { name: "教育部", url: "http://www.moe.gov.cn/" },
        { name: "文旅部", url: "http://www.mct.gov.cn/" },
        { name: "商务部", url: "http://www.mofcom.gov.cn/" },
        { name: "财政部", url: "http://www.mof.gov.cn/" },
        { name: "国家数据局", url: "http://www.nda.gov.cn/sjj/index_pc.html" },
      ],
    };
  },
  computed: {
    formattedDate() {
      const daysOfWeek = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];

      const year = this.currentDate.getFullYear(); // 获取年份
      const month = this.currentDate.getMonth() + 1; // 获取月份（0~11，所以加1）
      const day = this.currentDate.getDate(); // 获取日期
      const weekday = daysOfWeek[this.currentDate.getDay()]; // 获取星期几

      return `${year}年${month}月${day}日 ${weekday}`; // 拼接成所需格式
    },
  },
  methods: {
    setHome() {
      // Logic to set homepage, can be customized
      alert("设置为首页");
    },
    addToFavorites() {
      // Logic for adding to favorites
      alert("加入收藏");
    },
    handleSearch() {
      console.log("Searching for:", this.searchQuery);
      // Implement search logic here
    },
    toSearch() {
      window.location.href = "http://www.sxcpzx.org.cn/select/wap/";
    },
    toPath(item) {
      if (item.link == "/aboutus") {
        this.$router.push({ path: "/aboutus" });
      } else {
        window.location.href = item.link;
      }
    },
  },
};
</script>

<style scoped>
@import url(../assets/css/style.css);
@import url(../assets/css/submenu.css);

.clear {
  clear: both;
}

.inner1 {
  height: 30px;
  width: 100%;
  /* 容器宽度，确保滚动条的宽度足够 */
  overflow: hidden;
  /* 隐藏超出的内容 */
}

.inner1 table tr td {
  height: 30px;
}

.inner1 table tr td a {
  float: left;
  margin: 0px 5px 0px 5px;
  color: #f60;
  line-height: 30px;
  overflow: hidden;
}

.scroll-table {
  width: 100%;
  table-layout: fixed;
  white-space: nowrap;
  /* 保证内容不换行 */
  animation: scroll-left 10s linear infinite;
  /* 设置动画，10秒完成一次循环，线性播放，重复 */
  display: flex;
}

.scroll-item {
  padding: 0 15px;
  /* 控制文字间距 */
}

@keyframes scroll-left {
  0% {
    transform: translateX(0);
    /* 从右侧开始 */
  }

  100% {
    transform: translateX(-50%);
    /* 滚动到表格的一半，第二部分开始跟上 */
  }
}

.search-input {
  height: 28px;
  line-height: 28px;
  border: 1px #ccc solid;
  float: left;
  width: 190px;
  margin: 0px 20px 0px 20px;
}

.module_footer {
  display: flex;
  justify-content: space-between;
}

.clear {
  clear: both;
}

.home-yqlj {
  font-weight: bold;
}

.home-dgyqlj {
  margin-left: 20px;
}

.tabhead2 {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.tabhead2 dd {
  display: inline-block;
  margin-right: 15px;
}

.tabcontentstyle3 a {
  display: inline-block;
  padding: 5px;
  color: #007bff;
  text-decoration: none;
}

.tabcontentstyle3 a:hover {
  text-decoration: underline;
}
.colorFont {
  color: #f90;
}
</style>